// removed by extract-text-webpack-plugin
module.exports = {"reaserchIput":"researchAndEquity_reaserchIput_2Gicw","research":"researchAndEquity_research_Kf8UP","equityNum":"researchAndEquity_equityNum_1ni98","trademark":"researchAndEquity_trademark_2a2o9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/baseInfo/researchAndEquity/researchAndEquity.scss
// module id = 1535
// module chunks = 0